import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import { useSidebar } from "../../App";

export default function CreateEp() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-guide">
      <style>{`
        .endpoint-guide {
          width: 100%;
          max-width: 1100px;
          margin: 0 auto;
          padding: 32px 22px 50px;
          box-sizing: border-box;
          font-family: "Segoe UI", Arial, sans-serif;
          color: #fff;

          line-height: 1.6;
        }

        /* Main Heading */
        .endpoint-guide h1 {
          margin: 0 0 8px;
          font-size: 36px;
          line-height: 1.2;
          font-weight: 700;
          color: #24517d;
        }

        /* Subtitle */
        .guide-subtitle {
          display: inline-block;
          margin: 4px 0 0;
          padding: 2px 0;
          font-size: 17px;
          line-height: 1.5;
          color: #fff;
          
        }

        .guide-intro {
          margin: 0 0 60px;
          font-size: 16px;
          color: #fff;
        }

        /* Section Heading */
        .endpoint-guide h2 {
          margin: 0 0 14px;
          font-size: 26px;
          line-height: 1.3;
          font-weight: 700;
          color: #2d72b5;
        }

        .guide-description {
          margin: 0 0 10px;
          font-size: 16px;
          line-height: 1.55;
          color: #fff;
        }

        /* Table */
        .guide-table-wrapper {
          width: 100%;
          overflow-x: auto;
          margin-top: 8px;
        }

        .guide-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          font-size: 14px;
          
        }

        .guide-table th {
          padding: 9px 10px;
          text-align: left;
          vertical-align: middle;
          
          color: #fff;
          border: 1px solid #aebdca;
          font-weight: 700;
        }

        .guide-table td {
          padding: 9px 10px;
          text-align: left;
          vertical-align: top;
          border:1px solid #fff;

          color: #fff;
          line-height: 1.55;

        }

        /* Column widths */
        .guide-table th:nth-child(1),
        .guide-table td:nth-child(1) {
          width: 16%;
        }

        .guide-table th:nth-child(2),
        .guide-table td:nth-child(2) {
          width: 31%;
        }

        .guide-table th:nth-child(3),
        .guide-table td:nth-child(3) {
          width: 23%;
        }

        .guide-table th:nth-child(4),
        .guide-table td:nth-child(4) {
          width: 30%;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .endpoint-guide {
            padding: 24px 16px 40px;
          }

          .endpoint-guide h1 {
            font-size: 28px;
          }

          .endpoint-guide h2 {
            font-size: 23px;
          }

          .guide-subtitle {
            font-size: 15px;
          }

          .guide-intro {
            margin-bottom: 40px;
          }

          .guide-table {
            min-width: 750px;
          }
        }
      `}</style>

      {/* Page Title */}
      <h1>{t("createEp.title", "WhiteHaX Endpoint and Profile User Guide")}</h1>

      {/* Subtitle */}
      <div className="guide-subtitle">
        {t("createEp.subtitle", "User-guide level details for Create a New AI Endpoint and Create Profile")}
      </div>

      {/* Intro */}
      <p className="guide-intro">
        {t("createEp.intro", "Prepared from local WhiteHaX Help assets.")}
      </p>

      {/* Quick Orientation */}
      <section>
        <h2>{t("createEp.quickOrientation.title", "Quick Orientation")}</h2>

        <p className="guide-description">
          {t("createEp.quickOrientation.description", "WhiteHaX uses two related objects before a scan runs: an endpoint and a profile. The endpoint stores how WhiteHaX connects to the AI system. The profile stores what WhiteHaX will test and which datasets or parameters it will use.")}
        </p>

        {/* Information Table */}
        <div className="guide-table-wrapper">
          <table className="guide-table">
            <thead>
              <tr>
                <th>{t("createEp.table.headers.object", "Object")}</th>
                <th>{t("createEp.table.headers.meaning", "Meaning")}</th>
                <th>{t("createEp.table.headers.createdWhere", "Created where")}</th>
                <th>{t("createEp.table.headers.usedFor", "Used for")}</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{t("createEp.table.rows.endpoint.object", "Endpoint")}</td>

                <td>
                  {t("createEp.table.rows.endpoint.meaning", "Connection definition for the AI target.")}
                </td>

                <td>
                  {t("createEp.table.rows.endpoint.createdWhere", "Configuration - AI Endpoints.")}
                </td>

                <td>
                  {t("createEp.table.rows.endpoint.usedFor", "Target URL, provider/model, MCP server, scripts, JSON request/response mapping, credentials.")}
                </td>
              </tr>

              <tr>
                <td>{t("createEp.table.rows.profile.object", "Profile")}</td>

                <td>
                  {t("createEp.table.rows.profile.meaning", "Defines what WhiteHaX should test and the datasets or parameters to use.")}
                </td>

                <td>
                  {t("createEp.table.rows.profile.createdWhere", "Configuration - Profiles.")}
                </td>

                <td>
                  {t("createEp.table.rows.profile.usedFor", "Scan configuration, test selection, datasets, parameters, and testing behavior.")}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}